import React, { useState, useContext, useEffect } from "react";
import Rate from "rc-rate";
import "rc-rate/assets/index.css";
// import ReactStars from "react-rating-stars-component";
import Swal from "sweetalert2";
import "./Comments.scss";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import BusinessContext from "context/BusinessContext";
import { connection } from "utils/apiConnection.ts";

import more from "../../assets/images/icons8-menu-vertical-30.png";

function CreateComment({ isProduct }) {
  const auth = useContext(WithAuthentication);
  const { product, bpid, setComments } = useContext(BusinessContext);
  const [commentTitle, setCommentTitle] = useState("");
  const [commentText, setCommentText] = useState("");
  const [proid, setProid] = useState(0);
  const [uid, setUid] = useState(null);
  const [rate, setRate] = useState(0);
  const onChangeTitle = (e) => {
    setCommentTitle(e.target.value);
  };
  const onChangeText = (e) => {
    setCommentText(e.target.value);
  };
  useEffect(() => {
    if (isProduct && product.id != "") {
      setProid(product.id);
    }
    if (!isProduct) {
      setProid(-1);
    }
    if (auth.userInfo.id != null) {
      setUid(auth.userInfo.id);
    }
  }, [product.id]);
  var jalaali = require("jalaali-js");
  async function apihandler(e) {
    e.preventDefault();
    if (commentTitle != "" && commentText != "") {
      let date = new Date();
      let result = await connection("Insert_Comments", {
        title: commentTitle,
        description: commentText,
        uid: uid,
        bpid: bpid,
        proid: proid,
        rate: rate,
        mtm: Math.floor(date.getTime() / 1000),
      });
      let newComment = {
        title: commentTitle,
        description: commentText,
        uid: uid,
        fullname: auth.userInfo.fullName,
        bpid: bpid,
        proid: proid,
        rate: rate,
        mtm: Math.floor(date.getTime() / 1000),
      };
      if (result.status) {
        theAlert(1);
        setComments((prevState) => [...prevState, newComment]);
      } else {
        theAlert(2);
      }
    } else {
      theAlert(3);
    }
  }
  function theAlert(type) {
    let my_icon = type === 1 ? "success" : "error";
    Swal.fire({
      icon: my_icon,
      title: `${type === 1 ? "تایید" : "خطا"} `,
      text: `${
        type === 1
          ? "اطلاعات شما با موفقیت ثبت شد"
          : type === 2
          ? "مشکلی در ثبت اطلاعات به وجود آمده است"
          : type === 3
          ? "عنوان و توضیحات کامنت را تکمیل کنید"
          : ""
      }`,
    });
  }
  if (auth.isLogged)
    return (
      <>
        <form className="mx-auto comments">
          <div className="d-flex my-4 comment-title-rate">
            <div className=" w-50 comment-title">
              <label className="mb-2">عنوان نظر:</label>
              <input
                className="shadow form-control p-2"
                value={commentTitle}
                onChange={onChangeTitle}
              />
            </div>
            <div className="mx-auto align-self-end">
              امتیاز:
              <Rate
                direction="rtl"
                style={{ fontSize: 30 }}
                defaultValue={0}
                allowHalf={true}
                allowClear={true}
                onChange={(e) => setRate(e)}
              ></Rate>
            </div>
          </div>

          <div className=" my-4">
            <label className="mb-2">شرح نظر:</label>
            <textarea
              className="shadow form-control p-3"
              style={{ width: "90%" }}
              value={commentText}
              onChange={onChangeText}
            />
          </div>
          <div className="d-flex">
            <button
              type="submit"
              className="btn btn-color text-light ms-auto me-5 my-2"
              onClick={apihandler}
            >
              ثبت نظر
            </button>
          </div>
        </form>
      </>
    );
  else
    return (
      <div>
        <div>برای ثبت نظر ابتدا وارد حساب کاربری شوید.</div>
        <hr />
      </div>
    );
}

function CommentList({ commentLists }) {
  const { bpid, setComments } = useContext(BusinessContext);
  const auth = useContext(WithAuthentication);
  let temp;
  temp = commentLists.sort(function (a, b) {
    return b.mtm - a.mtm;
  });
  function theAlert(type) {
    let my_icon = type === 1 ? "success" : "error";
    Swal.fire({
      icon: my_icon,
      title: `${type === 1 ? "تایید" : "خطا"} `,
      text: `${
        type === 1
          ? "پیام شما با موفقیت حذف شد."
          : type === 2
          ? "مشکلی در حذف پیام به وجود آمده است."
          : ""
      }`,
    });
  }
  async function apihandler(value) {
    let result = await connection("Delete_Comments", {
      conditions: `id/=/${value.id}`,
    });
    if (result.status == 1) {
      theAlert(1);
      setComments((prevState) => prevState.filter((val) => val.id != value.id));
    } else theAlert(2);
  }
  let admin = auth.userInfo.shopIds.find((value) => value.id == bpid);
  return (
    <>
      {temp.map((Value, index) => {
        var date = new Date(Value.mtm * 1000);
        return (
          <div className=" card comment-list mx-auto my-4 shadow" key={index}>
            <div className="card-header fs-14 d-flex justify-content-between bg-color-blue text-light round-top align-items-center">
              <div className="ms-4">{Value.fullname}</div>
              <div className="d-flex align-items-center">
                <div className="me-3">
                  {new Intl.DateTimeFormat("fa-IR", {
                    dateStyle: "full",
                    timeStyle: "short",
                  }).format(date)}
                </div>
                {auth.isLogged && Value.uid == auth.userInfo.id ? (
                  <div style={{ textAlign: "left" }}>
                    <div class="btn-group dropend">
                      <button
                        type="button"
                        class="btn dropdown-toggle the-btn"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img src={more} alt="more" />
                      </button>
                      <ul class="dropdown-menu">
                        <li>
                          <div
                            class="dropdown-item"
                            onClick={(e) => apihandler(Value)}
                          >
                            حذف
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                ) : auth.isLogged && admin ? (
                  <div style={{ textAlign: "left" }}>
                    <div class="btn-group dropend">
                      <button
                        type="button"
                        class="btn dropdown-toggle the-btn"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img src={more} alt="more" />
                      </button>
                      <ul class="dropdown-menu">
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            onClick={(e) => apihandler(Value.id)}
                          >
                            حذف
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="card-body bg-color-gray round round-bottom">
              <div className="d-sm-flex flex-sm-row-reverse justify-content-between">
                <div style={{ direction: "ltr" }} className="d-flex stars">
                  <Rate
                    disabled={true}
                    allowHalf={true}
                    direction="rtl"
                    style={{ fontSize: 20 }}
                    count={5}
                    value={Value.rate}
                    defaultValue={Value.rate}
                  ></Rate>
                </div>
                <div>
                  <span className="title-style">عنوان نظر:</span>
                  <span className="ms-2">{Value.title}</span>
                </div>
              </div>
              <div className="d-flex my-2">
                <div className="title-style">شرح نظر:</div>
                <div className="ms-2">{Value.description}</div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}

export default CreateComment;
export { CommentList };
